import React from 'react';
import PropTypes from 'prop-types';
import Typeahead from 'react-bootstrap-typeahead';

const TypeaheadField = (props) => {
  const {
    name, value, meta: { touched, error }, addresses,
    placeholder, minLength, emptyLabel, onInputChange, onChange
  } = props;
  const hasError = touched && error;
  const errorClass = hasError ? 'form-field-error ' : '';
  return (
    <div className="typeahead-field">
      <input name={name} type="hidden" value={value} />
      <Typeahead
        className={`${errorClass} ca-typeahead auto-test-ca-address-search`}
        options={addresses}
        minLength={minLength}
        labelKey="label"
        emptyLabel={emptyLabel}
        onInputChange={onInputChange}
        onChange={onChange}
        filterBy={options => options}
        placeholder={placeholder}
        disabled={false}
      />
      {hasError &&
      <span className="form-validation-message">{error}</span>
      }
    </div>
  );
};

TypeaheadField.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  addresses: PropTypes.arrayOf(PropTypes.object),
  placeholder: PropTypes.string,
  minLength: PropTypes.number,
  emptyLabel: PropTypes.string,
  meta: PropTypes.object,
  onInputChange: PropTypes.func,
  onChange: PropTypes.func
};

export default TypeaheadField;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/CreditAssessmentStep2/TypeaheadField.js
 **/